import { SiteHeader as Header } from "@jkast90/kast-common/ui";
import { useLocation } from "react-router-dom";
import { useShopStatus } from "../hooks/useShopStatus";
import { AccountControls } from "../account-kit";
import styles from "./SiteHeader.module.css";

const NAV_LINKS: { href: string; label: string; gate?: "shop" }[] = [
  { href: "/about", label: "The HnT Story" },
  { href: "/road-adoptions", label: "Road Adoptions" },
  { href: "/impact", label: "Impact" },
  { href: "/gallery", label: "Gallery" },
  { href: "/shop", label: "Shop", gate: "shop" },
  { href: "/work-with-us", label: "Work with us" },
];

export default function SiteHeader() {
  const status = useShopStatus();
  const { pathname } = useLocation();
  // Show the link to the public, and also to admins running a preview.
  const shopVisible = status?.enabled === true || status?.preview === true;
  const links = NAV_LINKS.filter((link) => link.gate !== "shop" || shopVisible);
  const active = links.find((l) => pathname === l.href || pathname.startsWith(`${l.href}/`));

  return (
    <Header
      className={styles.header}
      variant="underline"
      sticky
      centerNav
      menuBelow={900}
      brand={{
        logo: "/hnt_logo_transparent.png",
        alt: "Hashers Not Trashers",
        title: "Hashers Not Trashers",
        tagline: "501(c)(3) Nonprofit",
      }}
      links={links}
      activeHref={active?.href}
      account={<AccountControls />}
    />
  );
}
